import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

import { HttpService } from './http.service';
import { urlLinks } from '../utility/url-links';

@Injectable()
export class FileService {

	constructor(private http: HttpService) { }

	/** Качване на файлове към дело */
	addFile(event: EventTarget, lawsuiteId: number, fileName: string, opisanie: string): Observable<any> {
		const eventObj = event as MSInputMethodContext;
		const target = eventObj.target as HTMLInputElement;
		const files: FileList | null = target.files;
		const formData: FormData = new FormData();

		if (files) {
			for (let i = 0; i < files.length; i++) {
				formData.append('file', files[i], files[i].name);
			}
		}

		const url =
			urlLinks.rest.cases.file.add +
			lawsuiteId +
			'&fileName=' + encodeURIComponent(fileName) +
			'&opisanie=' + encodeURIComponent(opisanie);

		return this.http.postFormData<any>(url, formData);
	}

	/** Списък с файловете към дело */
	getFiles(lawsuiteId: number): Observable<any> {
		return this.http.get<any>(urlLinks.rest.cases.file.list + lawsuiteId);
	}

	/** Изтриване на файл */
	deleteFile(fileId: number): Observable<any> {
		return this.http.delete<any>(urlLinks.rest.cases.file.delete + fileId);
	}

	/** Сваляне на файл като Blob */
	downloadFile(fileId: number, fileName: string): Observable<HttpResponse<Blob>> {
		const url =
			urlLinks.rest.cases.file.download +
			'fileId=' + fileId +
			'&fileName=' + encodeURIComponent(fileName);

		return this.http.postBlob(url, null);
	}
}
